import { QuestionBase } from './question-base';

/*

Sample:

new PasswordboxQuestion({
  key: 'password',
  label: 'nouns.password',
  required: true,
  order: 2
}),

*/
export class PasswordboxQuestion extends QuestionBase<string> {
  controlType = 'passwordbox';
  type: string;
  checkStrength: boolean;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || 'password';
    this.checkStrength = options['checkStrength'] || false;
  }
}
